import { createFileRoute } from "@tanstack/react-router";
import { loadLegalPage } from "~/utils/content-fns";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/legal/$slug")({
  loader: ({ params }) => loadLegalPage({ data: { slug: params.slug } }),
  head: ({ loaderData }) => ({
    meta: loaderData
      ? seo({
          title: loaderData.seo_title || loaderData.title,
          description: loaderData.seo_description,
          url: `/legal/${loaderData.slug}`,
          noindex: loaderData.robots === "noindex",
        })
      : [],
    links: loaderData ? seoLinks({ url: `/legal/${loaderData.slug}` }) : [],
  }),
  component: LegalPage,
});

function LegalPage() {
  const page = Route.useLoaderData();
  return (
    <article className="mx-auto max-w-3xl px-4 py-16 md:px-8">
      <h1 className="mb-8 text-4xl font-bold text-charcoal">{page.title}</h1>
      <div className="content" dangerouslySetInnerHTML={{ __html: page.html }} />
    </article>
  );
}
